import axios from 'axios'

// Get all Signatures (admin)
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/signature/all`)
  return data
}

// Update Signature
const update = async (id, price, period, newProduct, nextDate, active) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/signature/${id}`, {
    price,
    period,
    newProduct,
    nextDate,
    active
  })
  return data
}

// Remove Signature
const remove = async (id) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/signature/${id}`)
  return data
}

export {
  getAll,
  update,
  remove
}
